import Image from 'next/image';

export default function Image2({
  quality = 75,
  ...props
}) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image quality={quality} {...props} />;
}
